// extracted by mini-css-extract-plugin
export default {"nav":"Navbar_nav__zr53y","menus":"Navbar_menus__LpYGb","menu":"Navbar_menu__CYprK"};